<template>
  <li class="UIDropdownListItem">
    <slot />
  </li>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.UIDropdownListItem {
  @include font-size-14px;
  list-style: none;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;

  &:hover {
    background-color: $color-neutral-5;
  }
}
</style>
